import { useState, useTransition } from "react";
import {
  Card,
  DatePicker,
  Button,
  Table,
  Tag,
} from "antd";
import {
  SearchOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { SelectEmployee } from "../components/SelectInput";
import { useSelector } from "react-redux";
import { getRequest } from "../utils/APICall";
import moment from "moment";

const { RangePicker } = DatePicker;

const PendingAttendance = () => {
  const { allEmployee } = useSelector((state) => state.employees);

  const [employeeId, setEmployeeId] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false)
  function removeDuplicatesByID(array) {
    const seen = new Set();
    return array.filter((item) => {
      if (seen.has(item.ID)) return false;
      seen.add(item.ID);
      return true;
    });
  }
  const filterData = removeDuplicatesByID(allEmployee || []);
  const handleSearch = async () => {
    const fromDate = moment(dateRange[0]?.$d).format("DD MMM YYYY")
    const toDate = moment(dateRange[1]?.$d).format("DD MMM YYYY")
    // console.log(fromDate, toDate, employeeId)

    try {
      setLoading(true)
      const res = await getRequest(`pendingouts?empid=${employeeId}&fromdate=${fromDate}&todate=${toDate}`)
      // console.log("response ",res)
      if (res?.success) {
        setData(res?.data);
      } else {
        setData(null)
      }
    } catch (error) {
      console.log(error)
      setData(null)
    } finally { 
      setLoading(false)
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "ATTDATE",
      key: "ATTDATE",
    },
    {
      title: "Name",
      dataIndex: "NAME",
      key: "NAME",
    },
    {
      title: "Department",
      dataIndex: "DEPARTMENT",
      key: "DEPARTMENT",
    },
    {
      title: "Time In",
      dataIndex: "ENTRYTIME",
      key: "ENTRYTIME",
    },
    {
      title: "Time Out",
      dataIndex: "LEAVEINGTIME",
      key: "LEAVEINGTIME",
      render: (value) =>
        value ? (
          value
        ) : (
          <Tag color="red" icon={<ClockCircleOutlined />}>
            Pending
          </Tag>
        ),
    },

  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            Pending Attendance (Time Out)
          </h1>
          <p className="text-gray-500">
            View employees with missing time-out entries
          </p>
        </div>

        {/* Filters */}
        <Card className="rounded-2xl shadow-sm mb-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
            {/* Employee */}
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Employee
              </label>
              <SelectEmployee
                employeeList={filterData}
                onChange={(value) => {
                  setEmployeeId(value);
                }}
                selectedEmployee={employeeId}
                customStyle="w-full"
                allLabel={{}}
              />

            </div>

            {/* Date Range */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Date Range
              </label>
              <RangePicker
                className="w-full h-10"
                format="DD-MM-YYYY"
                onChange={(dates) => setDateRange(dates)}
              />
            </div>

            {/* Search */}
            <Button
              type="primary"
              size="large"
              loading={loading}
              icon={<SearchOutlined />}
              disabled={!employeeId || dateRange?.length === 0}
              onClick={handleSearch}
              className="rounded-lg"
            >
              Search
            </Button>
          </div>
        </Card>

        {/* Table */}
        <Card className="rounded-2xl shadow-sm">
          <Table
            columns={columns}
            dataSource={data}
            pagination={{ pageSize: 5 }}
            locale={{
              emptyText: "No attendance records found",
            }}
          />
        </Card>
      </div>
    </div>
  );
};

export default PendingAttendance;
